module.exports = require("@workbench-stack/module-server");